var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('organisationtype',{attrs:{"organisationtypes":_vm.organisationTypes},on:{"organisationTypeChange":function($event){return _vm.getOrganisationTypes()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }